/**
 * SPA routes that must not hard-redirect to /login when a session probe 401s.
 * Keep in sync with public <Route> entries in App.js.
 */
export function isPublicSpaPath(pathname) {
  if (!pathname) return false;
  if (pathname === '/') return true;

  const prefixes = [
    '/book/',
    '/vote/',
    '/q/',
    '/qi/',
    '/p/',
    '/p/status/',
    '/use-cases',
    '/m/',
    '/host/',
    '/landlord/',
    '/reschedule/',
    '/save-event',
    '/tour/',
    '/auth/callback',
    '/auth/social',
  ];
  if (prefixes.some((p) => pathname.startsWith(p))) return true;

  const exact = new Set([
    '/login',
    '/register',
    '/pending',
    '/forgot-password',
    '/reset-password',
    '/privacy',
    '/terms',
    '/help',
    '/tutorials',
    '/legal/data-processing',
    '/legal/offer',
    '/legal/marketing',
    '/legal/third-party-messaging',
    '/legal/dpa',
  ]);
  if (exact.has(pathname)) return true;
  if (pathname.startsWith('/legal/')) return true;
  if (pathname.startsWith('/docs/')) return true;

  return false;
}

/** @returns {boolean} true when a 401 on this path should navigate to /login */
export function shouldRedirectToLoginOn401(pathname, { isGated = false } = {}) {
  if (isGated) return false;
  return !isPublicSpaPath(pathname);
}
